import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "container"]

  connect() {
    this.handleSubmit  = this.onSubmit.bind(this)
    this.handleEnd     = this.onEnd.bind(this)

    this.element.closest("form")?.addEventListener("submit", this.handleSubmit)
    document.addEventListener("turbo:submit-end", this.handleEnd)
  }

  disconnect() {
    this.element.closest("form")?.removeEventListener("submit", this.handleSubmit)
    document.removeEventListener("turbo:submit-end", this.handleEnd)
    clearTimeout(this.timer)
  }

  onSubmit() {
    const form = this.element.closest("form")
    const hasFile = Array.from(form?.querySelectorAll('input[type="file"]') || []).some(el => el.files?.length > 0)
    if (!hasFile) return

    this.containerTarget.classList.remove("hidden")
    this.setWidth(0)

    // Animate to 85% — leaves room to jump to 100% on response
    this.animateTo(85, 2000)
  }

  onEnd() {
    clearTimeout(this.timer)
    this.setWidth(100)

    setTimeout(() => this.containerTarget.classList.add("hidden"), 600)
  }

  animateTo(target, duration) {
    const start     = performance.now()
    const startVal  = parseFloat(this.barTarget.style.width) || 0

    const step = (now) => {
      const elapsed  = now - start
      const progress = Math.min(elapsed / duration, 1)
      // ease-out curve
      const eased    = 1 - Math.pow(1 - progress, 3)
      this.setWidth(startVal + (target - startVal) * eased)
      if (progress < 1) this.timer = requestAnimationFrame(step)
    }

    this.timer = requestAnimationFrame(step)
  }

  setWidth(percent) {
    this.barTarget.style.width = `${percent}%`
  }
}
